import React, { useState, useRef, useImperativeHandle, useEffect } from 'react'
import BotonAnadir from '../componentes/CreadorPaginas/BotonAnadir'
import Canvas from './Canvas'
import { useImmer } from 'use-immer'
import { uid } from 'uid';
import { SortableContext, arrayMove, verticalListSortingStrategy } from '@dnd-kit/sortable';
import {
    MDBInput,
    MDBModal,
    MDBModalBody,
} from 'mdbreact';
import { campos } from './Campos';
import MostrarComponentes from '../componentes/CreadorPaginas/MostrarComponentes';
import { forwardRef } from 'react';
import { Titulos, peticionDelete } from '../hooks/Funciones'
import useTraeDatos from '../hooks/useTraeDatos';
import Header from '../componentes/Header';
import VerPaginas from './VerPaginas';
import axios from 'axios';
import Eliminar from '../componentes/Eliminar';
import { jsonrepair } from 'jsonrepair';



const getAncestors = (target, fields, ancestors = []) => {
    for (let [index, node] of fields.entries()) {
        if (node.id === target) {
            return ancestors.concat(index)
        }
        const found = getAncestors(target, node.fields, ancestors.concat(index));

        if (found) {
            return found
        }
    }
    return undefined;
};


export const CreadorPaginas = forwardRef(({ editarChildren, baseUrl, titulo, cerrarModal }, ref) => {
    const TitulosPagina = ['Ver Paginas', 'Crear Pagina', 'Editar Pagina', 'Eliminar Pagina', 'Paginas']
    const [tituloPag, setTituloPag] = useState(titulo)
    const [registroSelect, setRegistroSelect] = useState({})
    const [funcion, setFuncion] = useState('ver')
    const [busqueda, setBusqueda] = useState('')
    const [cargas, setCargas] = useTraeDatos(baseUrl)
    const [copiaCargas] = useTraeDatos(baseUrl)
    const [registro, setRegistro] = useState()

    const [mostrarInformacion, setMostrarInformacion] = useState(false)

    const [datos, ActualizarDatos] = useImmer({
        fields: []
    });
    const { fields } = datos;
    const [datosModal, actualizarDatosModal] = useImmer({
        id: null
    });

    const [modal, setModal] = useState(false);

    const seleccionaRegistro = (dato, funcion) => e => {
        const fielsDatos = JSON.parse(jsonrepair(dato?.datos))
        if (funcion === 'editar') {
            setRegistroSelect({ ...dato })
            setRegistro({ ...dato })
            ActualizarDatos((draft) => {
                draft.fields = fielsDatos
            })
        }
        if (funcion === 'eliminar') {
            setRegistroSelect({ ...dato })
        }
        setFuncion(funcion === 'eliminar' ? 'eliminar' : 'editar')
    }

    const RecibeBusqueda = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }



    const filtrar = (termino) => {
        let resultado = copiaCargas.filter((item) => {
            if (item.nombre.toLowerCase().includes(termino.toLowerCase())) {
                return item
            }
        })
        setCargas(resultado)
    }

    const peticionDeletee = () => { peticionDelete(registroSelect, baseUrl, cargas, setCargas, setFuncion) }
    useEffect(() => { Titulos(funcion, setTituloPag, TitulosPagina) }, [funcion])

    const ReiniciarPaginacion = () => {
        setCargas(copiaCargas)
        setBusqueda('')
    }



    const columnasSeleccionadas = (e) => {
        const { value } = e.target
        if (!value) return null
        const id = `${uid()}${fields.length + 1}`

        const nuevoFields = {
            id,
            type: 'divPrincipal',
            name: `divPrincipal${fields.length + 1}`,
            fields: [],
            styles: {}
        }

        for (let index = 0; index < parseInt(value); index++) {

            nuevoFields.fields.push({
                id: uid(),
                type: 'divPrincipal',
                name: `divPrincipal`,
                fields: [{
                    id: uid(),
                    type: 'agregarCampos',
                    name: `agregarCampos`,
                    styles: {},
                    fields: [{
                        id: uid(),
                        type: 'agregarCampos',
                        name: `agregarCampos`,
                        styles: {},
                        fields: []
                    }]
                }],
                styles: {}
            })
        }

        ActualizarDatos((draft) => {
            draft.fields = [...draft.fields, nuevoFields]
        })
        setMostrarInformacion(!mostrarInformacion)
    }


    const campoSeleccionado = ({ campo }) => {
        const indexs = getAncestors(datosModal.id, fields)

        ActualizarDatos((draft) => {
            draft.fields[indexs[0]].fields[indexs[1]].fields[indexs[2]].fields[indexs[3]].type = campo.type
            draft.fields[indexs[0]].fields[indexs[1]].fields[indexs[2]].fields[indexs[3]].name = campo.type
        })

        mostrarModal()
    }

    const handleMostrarModal = (id) => {
        actualizarDatosModal((draft) => {
            draft.id = id;
        })
        mostrarModal()
    }

    const handleDragEnd = (event) => {

        const { active, over } = event;
        if (!active.id !== over.id) {

            ActualizarDatos((draft) => {
                const oldIndex = getAncestors(active.id, fields)
                const newIndex = getAncestors(over.id, fields)

                if (oldIndex.length === 4) {
                    draft.fields[oldIndex[0]].fields[oldIndex[1]].fields[oldIndex[2]].fields = arrayMove(draft.fields[oldIndex[0]].fields[oldIndex[1]].fields[oldIndex[2]].fields, oldIndex[3], newIndex[3]);
                }

                if (oldIndex.length === 3) {
                    draft.fields[oldIndex[0]].fields[oldIndex[1]].fields = arrayMove(draft.fields[oldIndex[0]].fields[oldIndex[1]].fields, oldIndex[2], newIndex[2]);
                }

                if (oldIndex.length === 2) {
                    draft.fields[oldIndex[0]].fields = arrayMove(draft.fields[oldIndex[0]].fields, oldIndex[1], newIndex[1]);
                }

                if (oldIndex.length === 1) {
                    draft.fields = arrayMove(draft.fields, oldIndex[0], newIndex[0]);
                }

            })
        }
    };


    const mostrarModal = () => setModal(!modal);

    const removerChildren = (id) => {
        const indexs = getAncestors(id, fields)


        ActualizarDatos((draft) => {

            if (indexs.length === 4) {
                const removerFields = [...fields[indexs[0]].fields[indexs[1]].fields[indexs[2]].fields];
                removerFields.splice(indexs[3], 1)
                draft.fields[indexs[0]].fields[indexs[1]].fields[indexs[2]].fields = removerFields
            }

            if (indexs.length === 3) {
                const removerFields = [...fields[indexs[0]].fields[indexs[1]].fields];
                removerFields.splice(indexs[2], 1)
                draft.fields[indexs[0]].fields[indexs[1]].fields = removerFields
            }

            if (indexs.length === 2) {
                const removerFields = [...fields[indexs[0]].fields];
                removerFields.splice(indexs[1], 1)
                draft.fields[indexs[0]].fields = removerFields
            }

            if (indexs.length === 1) {
                const removerFields = [...fields];
                removerFields.splice(indexs[0], 1)
                draft.fields = removerFields
            }
        })

    }

    const anadirHijos = (id) => {
        const indexs = getAncestors(id, fields)
        const fieldsActual = {
            id: uid(),
            type: 'agregarCampos',
            name: `agregarCampos`,
            styles: {},
            fields: [{
                id: uid(),
                type: 'agregarCampos',
                name: `agregarCampos`,
                styles: {},
                fields: [{
                    id: uid(),
                    type: 'agregarCampos',
                    name: `agregarCampos`,
                    styles: {},
                    fields: []
                }]
            }]
        }

        ActualizarDatos((draft) => {
            if (indexs.length === 3) {
                draft.fields[indexs[0]].fields[indexs[1]].fields[indexs[2]].fields = [...fields[indexs[0]].fields[indexs[1]].fields[indexs[2]].fields, fieldsActual]
            }

            if (indexs.length === 2) {
                draft.fields[indexs[0]].fields[indexs[1]].fields = [...fields[indexs[0]].fields[indexs[1]].fields, fieldsActual]
            }

            if (indexs.length === 1) {
                draft.fields[indexs[0]].fields = [...fields[indexs[0]].fields, fieldsActual]
            }
        })
    }


    useImperativeHandle(
        ref,
        () => ({
            handleEstilosComponente(props) {
                ActualizarDatos((draft) => {
                    const indexs = getAncestors(props.id, fields)
                    if (indexs.length === 4) {
                        draft.fields[indexs[0]].fields[indexs[1]].fields[indexs[2]].fields[indexs[3]].styles[props.nombre] = props.valor
                    }

                    if (indexs.length === 3) {
                        draft.fields[indexs[0]].fields[indexs[1]].fields[indexs[2]].styles[props.nombre] = props.valor
                    }

                    if (indexs.length === 2) {
                        draft.fields[indexs[0]].fields[indexs[1]].styles[props.nombre] = props.valor
                    }

                    if (indexs.length === 1) {
                        draft.fields[indexs[0]].styles[props.nombre] = props.valor
                    }
                })
            }
        }),
    )

    const peticionPost = async (event) => {
        event.preventDefault();

        if (fields.length === 0) return setRegistro({ ...registro, error: 'Cree por favor la pagina antes de guardar' })

        let { nombre, menu = false, url } = registro

        let f = new FormData()

        f.append('nombre', nombre)
        f.append('menu', menu)
        f.append('url', url)
        f.append('datos', JSON.stringify(fields))
        f.append('METHOD', 'POST')

        const resultado = await axios.post(baseUrl, f)
        setCargas([...cargas, { ...resultado.data }])
        setFuncion('ver')
        cerrarModal()

    }
    const procedimientoPut = async (event) => {
        event.preventDefault();
        if (fields.length === 0) return setRegistro({ ...registro, error: 'Cree por favor la pagina antes de guardar' })

        let { nombre, menu, url } = registro

        let f = new FormData()

        f.append('nombre', nombre)
        f.append('menu', menu)
        f.append('datos', JSON.stringify(fields))
        f.append('url', url)
        f.append('id', registro.id)
        f.append('METHOD', 'PUT')

        const resultado = await axios.post(baseUrl, f)

        let dataNueva = cargas
        dataNueva.map(item => {
            if (item.id === registro.id) {
                item.nombre = nombre
                item.menu = menu
                item.url = url
                item.datos = JSON.stringify(fields)
                item.menu = menu
            }
        })

        setCargas(dataNueva)
        setFuncion('ver')
        cerrarModal()
    }

    const validarNombrePagina = (nombre) => {
        if (funcion === 'editar' && nombre == 'Menu') return true;
        if (funcion === 'editar' && nombre == 'Footer') return true;
        return false
    }
    const Componente = <>
        {registro?.error && <p className='red-text'>{registro?.error}</p>}
        <div className='creador-paginas'>
            <Canvas handleDragEnd={handleDragEnd} editarChildren={editarChildren} anadirHijos={anadirHijos} fields={fields} handleMostrarModal={handleMostrarModal} removerChildren={removerChildren} />
            <BotonAnadir columnasSeleccionadas={columnasSeleccionadas} mostrarInformacion={mostrarInformacion} setMostrarInformacion={setMostrarInformacion} />
        </div>

        <form onSubmit={funcion === 'editar' ? procedimientoPut : peticionPost}>

            <div className='row'>
                <div className='col-md-6'>
                    <MDBInput
                        label="Nombre" name="nombre" required outline
                        value={registro?.nombre}
                        disabled={validarNombrePagina(registro?.nombre)}
                        onChange={e => setRegistro({ ...registro, nombre: e.target.value })}
                    />
                </div>
                <div className='col-md-6'>
                    <MDBInput
                        label="Url" name="url" required outline
                        value={registro?.url}
                        disabled={validarNombrePagina(registro?.nombre)}
                        onChange={e => setRegistro({ ...registro, url: e.target.value })}
                    />
                </div>
                <div className='col-md-12'>
                    <div className='custom-control custom-switch '>
                        <input type='checkbox' name="menu" className='custom-control-input form-control-lg mb-4' id='customSwitches'
                            checked={String(registro?.menu) == "true" ? true : false}
                            disabled={validarNombrePagina(registro?.nombre)}
                            onChange={e => setRegistro({ ...registro, menu: e.target.checked })}
                        />
                        <label className='custom-control-label' htmlFor='customSwitches'>Menu</label>
                    </div>
                </div>
                <br />

                <div className="col text-center">
                    <button type='submit' className="btn boton_estandar">{tituloPag} </button>
                </div>

            </div>


        </form>
        <MDBModal isOpen={modal} tabIndex='-1' toggle={mostrarModal} className='modal-componente'>
            <MDBModalBody>
                <MostrarComponentes campos={campos} campoSeleccionado={campoSeleccionado} />
            </MDBModalBody>
        </MDBModal>
    </>

    const seleccionarFuncion = (funcion) => {
        if (funcion === 'crear' || funcion === 'ver') {
            ActualizarDatos((draft) => {
                draft.fields = []
            })
            setRegistro({})
        }
        cerrarModal()
        setFuncion(funcion)
    }
    return (
        <>
            <Header
                titulo={tituloPag}
                funcion={funcion}
                setFuncion={seleccionarFuncion}
                Pagina={'Cursos'}
                RecibeBusqueda={RecibeBusqueda}
                busqueda={busqueda}
                resetBusq={ReiniciarPaginacion}
            />

            {funcion === 'crear' ?
                Componente
                :
                funcion === 'editar' ?
                    Componente
                    :
                    null}

            {funcion === 'ver' ?
                <VerPaginas
                    data={cargas}
                    seleccionaRegistro={seleccionaRegistro}
                    baseUrl={baseUrl}
                />
                : null}
            {funcion === 'eliminar' ?
                <Eliminar
                    nombre={'Pagina'}
                    select={registroSelect}
                    setFuncion={setFuncion}
                    peticionDelete={peticionDeletee} />

                : null}
        </>

    )
})